// LinkedLegs.tsx
import { makeStyles } from '@material-ui/core';
import { LoadTableRow } from 'doc-mate-store/lib/models';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import LinkedLegsInfo from './LinkedLegsInfo';
import LinkIcon from './LinkIcon.svg';

type Props = {
  cell?: {
    value: any;
  };
  row: {
    original: LoadTableRow;
  };
};

const LinkedLegs: React.FC<Props> = ({ cell, row }) => {
  const [isHovering, setIsHovering] = useState<boolean>(false);
  const classes = useStyles();

  const load = row?.original;
  const linkedLegs =
    load?.linkedLegs || (Array.isArray(cell?.value) ? cell.value : []);
  const manifestLegs = load?.manifestLegs || [];

  const isLinked = linkedLegs.length > 0;
  // Render icon if explicitly linked OR if more than 1 order leg exists under the manifest
  const hasMultipleLegs = isLinked || manifestLegs.length > 0;

  // Linked legs display their linked counterparts; unlinked legs display other manifest legs
  const legsToDisplay = isLinked ? linkedLegs : manifestLegs;

  const handleMouseEnter = () => setIsHovering(true);
  const handleMouseLeave = () => setIsHovering(false);

  if (!hasMultipleLegs) {
    return null;
  }

  return (
    <div className={classes.onTop}>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <img src={LinkIcon} alt="Link" />
        {isHovering && (
          <LinkedLegsInfo isLinked={isLinked} legInfoList={legsToDisplay} />
        )}
      </div>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  onTop: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    verticalAlign: 'top',
    alignItems: 'center',
    width: '100%',
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
  },
}));

export default observer(LinkedLegs);
